import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/lp/t-shirt/TShirtLandingPage.tsx");
